import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
}

export function Skeleton({ width = '100%', height = '1rem', radius = 8 }: SkeletonProps): JSX.Element {
  return (
    <span
      className={styles.bar}
      style={{
        width,
        height,
        borderRadius: typeof radius === 'number' ? `${radius}px` : radius,
      }}
    />
  );
}
